//TODO: replace with src/components/Grid/Creatives/index.tsx
import type CreativeType from '@/Enums/Creatives/CreativeType.enum';
import { Grid } from '@/components/Grid';
import ServerSidePagination from '@/components/Grid/Pagination/ServerSidePagination';
import {
  GridPaginationAndSortFilters,
  useGridApiPaginationAndSort,
} from '@/components/Grid/hooks/useGridApiPaginationAndSort';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { GridColDef, GridRowSelectionModel, GridValidRowModel } from '@mui/x-data-grid-pro';
import { memo, useEffect } from 'react';

interface ICreativesTableProps {
  loading?: boolean;
  tableData: GridValidRowModel[];
  rowCount?: number;
  columns: GridColDef[];
  checkboxSelection: boolean;
  rowSelectionModel: GridRowSelectionModel;
  withoutPagination?: boolean;
  handleRowSelectionModelChange: (model: GridRowSelectionModel) => void;
  selectedCreativesTypes?: CreativeType[];
  setTableFilters: (filters: GridPaginationAndSortFilters) => void;
  isRowSelectable?: (params: any) => boolean;
}

const CreativesTable = memo(
  ({
    loading,
    tableData,
    rowCount,
    columns,
    checkboxSelection,
    rowSelectionModel,
    withoutPagination,
    handleRowSelectionModelChange,
    selectedCreativesTypes,
    setTableFilters,
    isRowSelectable,
  }: ICreativesTableProps) => {
    const { paginationModel, sortModel, handlePaginationModelChange, handleSortModelChange, handleReset } =
      useGridApiPaginationAndSort({ setFilters: setTableFilters });

    useEffect(() => {
      handleReset();
    }, [handleReset, selectedCreativesTypes]);

    return (
      <Grid
        loading={loading}
        checkboxSelection={checkboxSelection}
        rows={tableData}
        columns={columns}
        columnHeaderHeight={40}
        rowHeight={70}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnFilter
        pagination={!withoutPagination}
        rowThreshold={0}
        columnThreshold={0}
        rowSelection
        onRowSelectionModelChange={handleRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        isRowSelectable={isRowSelectable}
        showCellVerticalBorder
        showColumnVerticalBorder
        disableCellSelection
        slots={{
          // @ts-expect-error
          pagination: ServerSidePagination,
          columnSortedAscendingIcon: KeyboardArrowUp,
          columnSortedDescendingIcon: KeyboardArrowDown,
        }}
        scrollbarSize={0}
        slotProps={{
          pagination: {
            // @ts-expect-error doesn't recognize rowCount
            rowCount,
            loading,
          },
        }}
        rowCount={rowCount}
        paginationMode={withoutPagination ? 'client' : 'server'}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        sortingMode='server'
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        hideFooter={withoutPagination}
      />
    );
  },
);

export default CreativesTable;
